import { render } from "./ver_turno_professor.vue?vue&type=template&id=13b8bfbc"
import script from "./ver_turno_professor.vue?vue&type=script&lang=js"
export * from "./ver_turno_professor.vue?vue&type=script&lang=js"

import "./ver_turno_professor.vue?vue&type=style&index=0&id=13b8bfbc&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__